import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styleButton from '../Button/Button.module.css'
import ModalCustom from "./modal-template-default";
import Button from '../Button';

const ModalImageView = props => {
  const { image, view, title, closeModal, isWaitingResponse, ...other } = props

  return (
    <>
      <ModalCustom
        {...other}
        size="lg"
        show={view}
        onHide={closeModal}
        disableClose={!!isWaitingResponse}
      >
        <ModalCustom.Header>
          <ModalCustom.Title>{title}</ModalCustom.Title>
        </ModalCustom.Header>
        <ModalCustom.Body>
          <Row>
            <Col>
              <img src={image} alt="" style={{ maxWidth: "100%" }} />
            </Col>
          </Row>
        </ModalCustom.Body>
        <ModalCustom.Footer>
          <Button
            disabled={isWaitingResponse}
            color="primary_ghost"
            onClick={closeModal}
          >
            Cancelar
          </Button>
          <a
            className={`ml-2 ${styleButton.button_primary}`}
            href={image}
            download
            onClick={closeModal}
          >
            Download
          </a>
        </ModalCustom.Footer>
      </ModalCustom>
    </>
  )
}

export default ModalImageView 